<svelte:body on:item={put_item} />
<script>
    // Калькулятор склада 54. В заказ уходит только количество.
    // Расход материалов берётся из связи шаблона, розница и опт — из options.
    import _ from 'lodash';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();
    const money = (value) => Math.round((Number(value) || 0) * 100) / 100;

    export let calc;
    export let options;

    const productName = 'Универсальная накидка на лобовое стекло автомобиля';

    export let put_item = async (e) => {
        let item = e.detail;

        if (item && item.name === productName) {
            count.set(+item.quantity || 1);
            comment.set(item.comment || '');
            fetchData = await fetch();
            change();
        }
    };

    const fetch = async () => {
        return await network.fetch_data('Накидка 54', '', '');
    };

    let fetchData = fetch();

    let
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    const change = _.debounce(async () => {
        let data = await fetchData;
        let quantity = +$count || 1;
        let sebest = 0;

        let result = {
            type: 'накидка',
            name: productName,
            subname: '',
            title: productName,
            params: {
                ind1: '',
                ind2: '',
                ind3: '',
                ind4: '',
                ind5: '',
                foto_small: '/img/nakidka/nakidka-54.jpg',
            },
            price: {rozn: 0, opt: 0, sebest: 0},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 176,
        };

        _.forEach(data, function (item) {
            let kolvo = Number(item.kolvo);
            if (!kolvo) {
                return;
            }

            sebest += kolvo * (Number(item.sebestomost) || 0);

            result.materials[item.name] = {
                order: +item.poryadok || 0,
                id: item.idTovar,
                percent: 0,
                spis: item.procentSpisania || 0,
                type: item.edIzmer,
                oprice: {
                    rozn: money(item.price).toFixed(2),
                    opt: money(item.opt_price).toFixed(2),
                    sebest: money(item.sebestomost).toFixed(2),
                },
                price: {rozn: 0, opt: 0, sebest: 0},
                quantity,
                count: kolvo.toFixed(3),
            };
        });

        result.price.rozn = money(options.rozn != null ? options.rozn : 800).toFixed(2);
        result.price.opt = money(options.opt != null ? options.opt : 550).toFixed(2);
        result.price.sebest = money(sebest).toFixed(2);

        dispatch('lock', {state: false});
        dispatch('item', result);
    }, 250);

    $: $count, $comment, change();

    change();
</script>

<style>
    .parent {
        display: grid;
        grid-template-columns: 1fr;
        grid-column-gap: 5px;
        grid-row-gap: 0;
        grid-template-areas:
            "pic"
            "count"
            "comment";
    }

    @media (min-width: 575.98px) {
        .parent {
            grid-template-columns: 1fr 1fr;
            grid-template-areas:
                "pic count"
                "pic comment";
        }
    }

    .pic { grid-area: pic; }
    .count { grid-area: count; }
    .comment { grid-area: comment; }
</style>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then}
    <div class="card-body">
        <div class="parent">
            <div class="pic text-center">
                <img style="max-height: 300px" class="img-fluid p-3" src="/img/nakidka/nakidka-54.jpg" alt={productName}/>
            </div>

            <div class="count">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="count">Количество</label>
                        <input id="count" type="number" class="form-control" min="1" bind:value={$count}>
                    </div>
                </div>
            </div>

            <div class="comment">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label" for="comment">Примечание</label>
                        <textarea id="comment" class="form-control" bind:value={$comment}></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}
